;(function($){
    $(document).ready(function(){
        $.fn.validate = function(options){

            const that = $(this);
            const elms = that.find('[data-validation]');

            const defaults = {
                alertIfInvalid: true,
                alertMsg: 'Oops! There were problems with the info you entered'
            };

            options = $.extend(defaults, options);

            let isCollectionValid = true;

            elms.each(function(index, element){
                const elm = $(element);

                elm.data('rules', elm.data('validation').split(','));

                let isElmValid = true;

                elm.data('rules').forEach(rule => {
                    switch (rule) {
                        case 'not-empty':
                            if ('' == elm.val() || null == elm.val()) {
                                isElmValid = false;
                                isCollectionValid = false;
                            }
                            break;

                        case 'not-value':
                            if (elm.data('value') == elm.val()) {
                                isElmValid = false;
                                isCollectionValid = false;
                            }
                            break;

                        case 'email':
                            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                            if (false == re.test(elm.val())) {
                                isElmValid = false;
                                isCollectionValid = false;
                            }
                            break;

                        case 'match-element':
                            const matchSelector = elm.data('match-element');

                            if (elm.val() !== that.find(matchSelector).val()) {
                                isElmValid = false;
                                isCollectionValid = false;
                            }
                            break;

                        case 'min-length':
                            const minLength = elm.data('min-length');

                            if (elm.val().length < parseInt(minLength)) {
                                isElmValid = false;
                                isCollectionValid = false;
                            }
                            break;

                        case 'max-length':
                            const maxLength = elm.data('max-length');

                            if (elm.val().length > parseInt(maxLength)) {
                                isElmValid = false;
                                isCollectionValid = false;
                            }
                            break;

                        case 'exact-length':
                            const exactLength = elm.attr('exact-length');

                            if (elm.val().length !== parseInt(exactLength)) {
                                isElmValid = false;
                                isCollectionValid = false;
                            }
                            break;

                        case 'atleast-1-checked':
                            if (0 == elm.find('input:checked').length) {
                                isElmValid = false;
                                isCollectionValid = false;
                            }
                            break;
                    }
                });

                if (false == isElmValid) {
                    if (elm.data('rules').includes('atleast-1-checked')) {
                        elm.find('.data-validation-error-elm').addClass('is-invalid');
                    } else if (elm.hasClass('select2-hidden-accessible')) {
                        elm.addClass('is-invalid').siblings('.select2-container').find('.select2-selection').addClass('is-invalid');
                    } else {
                        elm.addClass('is-invalid');
                    }

                    const errorMessage = elm.attr('data-validation-error');
                    if (typeof errorMessage !== typeof undefined && errorMessage !== false) {

                        // is this input part of an input group?
                        let errorMsgSiblingElm = elm;
                        if (elm.parent().hasClass('input-group')) {
                            errorMsgSiblingElm = elm.parent();
                        }

                        let existingError = errorMsgSiblingElm.find('+ p.error-message'),
                            elmLabel      = errorMsgSiblingElm.siblings('label');

                        if (1 == existingError.length) {
                            existingError.html(errorMessage);
                        } else {
                            errorMsgSiblingElm.after(
                                $('<p></p>').addClass('error-message').html(errorMessage)
                            );
                        }

                        if (elmLabel.length > 0) {
                            elmLabel.addClass('has-error');
                        }
                    }
                }
            });

            if (!isCollectionValid && options.alertIfInvalid) {

            }

            return isCollectionValid;
        };

        let body = $('body');

        body.on('keypress blur change', '.is-invalid[data-validation]', function(){
            var elm = $(this);

            if (elm.hasClass('select2-hidden-accessible')) {
                elm.siblings('.select2-container').find('.select2-selection').removeClass('is-invalid');
            } else {
                elm.removeClass('is-invalid');
            }

            // is this input part of an input group?
            let errorMsgSiblingElm = elm;
            if (elm.parent().hasClass('input-group')) {
                errorMsgSiblingElm = elm.parent();
            }

            const errorMsg = errorMsgSiblingElm.find('+ p.error-message')

            if (1 == errorMsg.length) {
                errorMsg.remove();
            }

            errorMsgSiblingElm.siblings('label.has-error').removeClass('has-error');
        });

        body.on('change', '[type="checkbox"]', function(){
            const self = $(this);

            self.parents('[data-validation]')
                .find('[name="' + self.attr('name') + '"]')
                .parents('label')
                .removeClass('is-invalid')
            ;
        });
    });
})(jQuery);